<template>
  <div class="dropdown grandfather home-wrapper">
    <span
      class="tab-sub-menu-btn tab-sub-menu-btn-left"
      v-if="direction === 'left'"
      :class="{ dis: mainTabPagination.nextTab === 2 }"
      @click="goHomeEmiter"
    >
      <i class="fas fa-angle-double-left"></i>
    </span>
    <span
      v-if="direction === 'left'"
      class="tab-sub-menu-btn"
      :class="{ dis: mainTabPagination.nextTab === 2 }"
      @click="emmitSetMainTabLeft"
    >
      <!--    <i class="far fa-arrow-alt-circle-left"></i>-->
      <i class="fas fa-angle-left" v-if="mainTabPagination.prevTab === 0"></i>
      <i class="fas fa-angle-left" v-if="mainTabPagination.prevTab === 1"></i>
      <i
        class="fas fa-angle-left"
        v-if="
          mainTabPagination.prevTab === 7 &&
            CheckUserPermission([1, 2, 3, 4, 12])
        "
      ></i>

      <i class="fas fa-angle-left" v-if="mainTabPagination.prevTab === 5"></i>
      <i class="fas fa-angle-left" v-if="mainTabPagination.prevTab === 6"></i>
      <i
        @click="questionSector = 1"
        class="fas fa-angle-left"
        v-if="mainTabPagination.prevTab === 2"
      ></i>
      <i
        @click="questionSector = 2"
        class="fas fa-angle-left"
        v-if="mainTabPagination.prevTab === 3"
      ></i>
      <i
        @click="questionSector = 3"
        class="fas fa-angle-left"
        v-if="mainTabPagination.prevTab === 4"
      ></i>

      <!--            <i class="fas fa-bars" v-if="mainTabPagination.prevTab === 0"></i>-->
      <!--      <i class="fas fa-bars" v-if="mainTabPagination.prevTab === 1"></i>-->
      <!--      <i-->
      <!--        class="fas fa-dollar-sign"-->
      <!--        v-if="-->
      <!--          mainTabPagination.prevTab === 7 &&-->
      <!--            CheckUserPermission([1, 2, 3, 4, 12])-->
      <!--        "-->
      <!--      ></i>-->

      <!--      <i class="fas fas fa-bullhorn" v-if="mainTabPagination.prevTab === 5"-->
      <!--        ><sub class="num-in-i">.I</sub></i-->
      <!--      >-->
      <!--      <i class="fas fas fa-bullhorn" v-if="mainTabPagination.prevTab === 6"-->
      <!--        ><sub class="num-in-i">.II</sub></i-->
      <!--      >-->
      <!--      <i-->
      <!--        @click="questionSector = 1"-->
      <!--        class="fas fas fa-question"-->
      <!--        v-if="mainTabPagination.prevTab === 2"-->
      <!--        ><sub class="num-in-i">.I</sub></i-->
      <!--      >-->
      <!--      <i-->
      <!--        @click="questionSector = 2"-->
      <!--        class="fas fa-question"-->
      <!--        v-if="mainTabPagination.prevTab === 3"-->
      <!--        ><sub class="num-in-i">.II</sub></i-->
      <!--      >-->
      <!--      <i-->
      <!--        @click="questionSector = 3"-->
      <!--        class="fas fa-question "-->
      <!--        v-if="mainTabPagination.prevTab === 4"-->
      <!--        ><sub class="num-in-i">.III</sub></i-->
      <!--      >-->
    </span>
    <span
      v-if="direction === 'right'"
      class="tab-sub-menu-btn"
      @click="emmitSetMainTabRight"
      :class="{ dis: disableButton(auth.user.role) }"
    >
      <i
        @click="questionSector = 1"
        class="fas fa-angle-right"
        v-if="mainTabPagination.nextTab == 2"
      ></i>
      <i
        @click="questionSector = 2"
        class="fas fa-angle-right"
        v-if="mainTabPagination.nextTab == 3"
      ></i>
      <i
        @click="questionSector = 3"
        class="fas fa-angle-right"
        v-if="mainTabPagination.nextTab == 4"
      ></i>

      <i
        @click="questionSector = null"
        class="fas fa-angle-right"
        v-if="mainTabPagination.nextTab === 5"
      ></i>
      <i
        @click="questionSector = null"
        class="fas fa-angle-right"
        v-if="mainTabPagination.nextTab === 6"
      ></i>
<!--              v-if="mainTabPagination.nextTab === 6 && auth.user.role !== 7"-->

      <i
        @click="questionSector = null"
        class="fas fa-angle-right"
        v-if="
          mainTabPagination.nextTab === 7 &&
            CheckUserPermission([1, 2, 3, 4, 7, 12])
        "
      ></i>
      <i
        class="fas fa-angle-right"
        v-if="
          mainTabPagination.nextTab === 8 &&
            CheckUserPermission([1, 2, 3, 4, 7, 12])
        "
      ></i>
      <!--          <i class="far fa-arrow-alt-circle-right" v-if="clientsTableSelectedTab.tabAlias !== 'questions' || mainTabPagination.nextTab > 4" @click="questionSector =null"></i>-->
      <!--            <i-->
      <!--              @click="questionSector = 1"-->
      <!--              class="far fa-arrow-alt-circle-right"-->
      <!--              v-if="mainTabPagination.nextTab == 2 && clientsTableSelectedTab.tabAlias === 'questions'"-->
      <!--              ></i-->
      <!--            >-->
      <!--            <i-->
      <!--              @click="questionSector = 2"-->
      <!--              class="far fa-arrow-alt-circle-right"-->
      <!--              v-if="mainTabPagination.nextTab == 3 && clientsTableSelectedTab.tabAlias === 'questions'"-->
      <!--              ></i-->
      <!--            >-->
      <!--            <i-->
      <!--              @click="questionSector = 3"-->
      <!--              class="far fa-arrow-alt-circle-right"-->
      <!--              v-if="mainTabPagination.nextTab == 4 && clientsTableSelectedTab.tabAlias === 'questions'"-->
      <!--              ></i-->
      <!--            >-->
      <!--      <i-->
      <!--        @click="questionSector = 1"-->
      <!--        class="fas fa-question"-->
      <!--        v-if="mainTabPagination.nextTab == 2"-->
      <!--        ><sub class="num-in-i">.I</sub></i-->
      <!--      >-->
      <!--      <i-->
      <!--        @click="questionSector = 2"-->
      <!--        class="fas fa-question "-->
      <!--        v-if="mainTabPagination.nextTab == 3"-->
      <!--        ><sub class="num-in-i">.II</sub></i-->
      <!--      >-->
      <!--      <i-->
      <!--        @click="questionSector = 3"-->
      <!--        class="fas fa-question "-->
      <!--        v-if="mainTabPagination.nextTab == 4"-->
      <!--        ><sub class="num-in-i">.III</sub></i-->
      <!--      >-->

      <!--      <i-->
      <!--        @click="questionSector = null"-->
      <!--        class="fas fas fa-bullhorn"-->
      <!--        v-if="mainTabPagination.nextTab === 5 && auth.user.role !== 7"-->
      <!--        ><sub class="num-in-i">.I</sub></i-->
      <!--      >-->
      <!--      <i-->
      <!--        @click="questionSector = null"-->
      <!--        class="fas fas fa-bullhorn"-->
      <!--        v-if="mainTabPagination.nextTab === 6 && auth.user.role !== 7"-->
      <!--        ><sub class="num-in-i">.II</sub></i-->
      <!--      >-->
      <!--      <i-->
      <!--        @click="questionSector = null"-->
      <!--        class="fas fa-dollar-sign"-->
      <!--        v-if="-->
      <!--          mainTabPagination.nextTab === 7 &&-->
      <!--            CheckUserPermission([1, 2, 3, 4, 12])-->
      <!--        "-->
      <!--      ></i>-->
      <!--      <i-->
      <!--        class="fas fa-dollar-sign dis"-->
      <!--        v-if="-->
      <!--          mainTabPagination.nextTab === 8 &&-->
      <!--            CheckUserPermission([1, 2, 3, 4, 12])-->
      <!--        "-->
      <!--      ></i>-->
    </span>
    <span
      class="tab-sub-menu-btn tab-sub-menu-btn-right"
      v-if="direction === 'right'"
      :class="{ dis: disableButton(auth.user.role) }"
      @click="goEndEmiter"
    >
      <i class="fas fa-angle-double-right"></i>
    </span>
    <div class="dropdown-menu sub-menu-dropup">
      <a
        v-for="tab in getTabList(tabsListLocal)"
        :key="tab.id"
        class="dropdown-item"
        role="button"
        @click="setTabClientsTable(tab.name, tab.alias)"
      >
        <i class="fas fa-bars" v-if="tab.name === 'STATUS'"></i>
        <i
          class="fas fa-dollar-sign"
          v-if="tab.name === 'COST' && CheckUserPermission([1, 2, 3, 4, 12])"
        ></i>
        <i
          @click="questionSector = 1"
          class="fas fa-question button-space"
          v-if="tab.name === 'QUESTIONS' && questionSector !== 1"
          ><sub class="num-in-i">.I</sub></i
        >
        <i
          @click="questionSector = 2"
          class="fas fa-question button-space"
          v-if="tab.name === 'QUESTIONS' && questionSector !== 2"
          ><sub class="num-in-i">.II</sub></i
        >
        <i
          @click="questionSector = 3"
          class="fas fa-question button-space"
          v-if="tab.name === 'QUESTIONS' && questionSector !== 3"
          ><sub class="num-in-i">.III</sub></i
        >
        <i class="fas fa-bullhorn" v-if="tab.name === 'CAMPAIGN'"></i>
      </a>
    </div>
  </div>
</template>

<script>
import UsersPermissionCheck from "../../../../../../mixins/user/auth/UsersPermissionCheck";
import FilterUsersByEmail from "../../../../../../mixins/user/auth/FilterUsersByEmail";
import { mapGetters, mapState } from "vuex";

export default {
  name: "HeaderSubMenuClientsTable",
  props: {
    tabsList: {
      type: Array,
      required: true
    },
    mainTabPagination: {
      type: Object,
      required: false
    },
    direction: {
      type: String,
      required: false
    }
  },
  mixins: [UsersPermissionCheck, FilterUsersByEmail],
  computed: {
    ...mapState("clients", ["clientsTableSelectedTab"])
  },
  data() {
    return {
      nextTab: "STATUS",
      selectedTabClientTable: "STATUS",
      questionSector: 1,
      tabsListLocal: [
        /*      {
              id: 2,
              name: "SIGNALS",
              alias: "signals"
            },*/
        {
          id: 3,
          name: "COST",
          alias: "cost",
          selectedSection: null
        },
        /*
            {
              id: 4,
              name: "Geo Campaign",
              alias: "geo_campaign"
            },
      */

        {
          id: 5,
          name: "CAMPAIGN",
          alias: "campaign",
          selectedSection: null
        },
        {
          id: 1,
          name: "QUESTIONS",
          alias: "questions",
          selectedSection: 1
        },
        {
          id: 6,
          name: "STATUS",
          alias: "status",
          selectedSection: null
        }
      ]
    };
  },

  methods: {
    // emmitSetMainTab() {
    //   switch (this.nextTab) {
    //     case "COST":
    //       this.setTabClientsTable("COST", "cost");
    //       break;
    //     case "CAMPAIGN":
    //       this.setTabClientsTable("CAMPAIGN", "campaign");
    //       break;
    //     case "STATUS":
    //       this.setTabClientsTable("STATUS", "status");
    //       break;
    //     case "QUESTIONS":
    //       this.setTabClientsTable("QUESTIONS", "questions");
    //       break;
    //     case "QUESTIONS1":
    //       this.setTabClientsTable("QUESTIONS", "questions");
    //       break;
    //     case "QUESTIONS2":
    //       this.setTabClientsTable("QUESTIONS", "questions");
    //       break;
    //     case "QUESTIONS3":
    //       this.setTabClientsTable("QUESTIONS", "questions");
    //       break;
    //   }
    // },
    goHomeEmiter() {
      let tempObj = {
        prevTab: 0,
        currentTab: 1,
        nextTab: 2,
        questionSector: null
      };
      this.$emit("paginate", tempObj);
      this.setTabClientsTable("STATUS", "status");
    },
    goEndEmiter() {
      let tempObj = {};
      if (this.auth.user.role === 7) {
        tempObj = {
          prevTab: 3,
          currentTab: 4,
          nextTab: 5,
          questionSector: 3
        };
      } else if (this.CheckUserPermission([1, 2, 3, 4, 5, 6, 8, 12])) {
        tempObj = {
          prevTab: 6,
          currentTab: 7,
          nextTab: 8,
          questionSector: null
        };
      }

      this.$emit("paginate", tempObj);
      if (this.auth.user.role !== 7) {
        this.setTabClientsTable("COST", "cost");
      } else {
        this.setTabClientsTable("QUESTIONS", "questions");
      }
    },
    paginationEmiter(direction) {
      if (direction === "left") {
        let tempObj = {
          prevTab: this.mainTabPagination.prevTab - 1,
          currentTab: this.mainTabPagination.currentTab - 1,
          nextTab: this.mainTabPagination.nextTab - 1,
          questionSector: this.questionSector
        };
        this.$emit("paginate", tempObj);
      }
      if (direction === "right") {
        let tempObj = {
          prevTab: this.mainTabPagination.prevTab + 1,
          currentTab: this.mainTabPagination.currentTab + 1,
          nextTab: this.mainTabPagination.nextTab + 1,
          questionSector: this.questionSector
        };
        this.$emit("paginate", tempObj);
        this.setTabClientsTable("STATUS", "status");
      }
    },
    emmitSetMainTabLeft() {
      if (this.mainTabPagination.prevTab !== 0) {
        this.paginationEmiter(this.direction);
      }
      switch (this.mainTabPagination.prevTab) {
        case 1:
          this.setTabClientsTable("STATUS", "status");
          break;
        case 2:
          this.setTabClientsTable("QUESTIONS", "questions");
          break;
        case 3:
          this.setTabClientsTable("QUESTIONS", "questions");
          break;
        case 4:
          this.setTabClientsTable("QUESTIONS", "questions");
          break;
        case 5:
          // if (this.auth.user.role !== 7) {
            this.setTabClientsTable("CAMPAIGN-1", "campaign");
          // }
          break;
        case 6:
          // if (this.auth.user.role !== 7) {
            this.setTabClientsTable("CAMPAIGN-2", "campaign-2");
          // }
          break;
        case 7:
          // if (this.auth.user.role !== 7) {
            this.setTabClientsTable("COST", "cost");
          // }
          break;
      }

      //
      // switch (this.mainTabPagination.nextTab) {
      //   case 0:
      //     // this.setTabClientsTable("STATUS", "status");
      //     break;
      //   case 6:
      //     if (this.auth.user.role !== 7) {
      //       this.setTabClientsTable("COST", "cost");
      //     }
      //     break;
      //   case 5:
      //     if (this.auth.user.role !== 7) {
      //       this.setTabClientsTable("CAMPAIGN", "campaign");
      //     }
      //     break;
      //   case 2:
      //     this.setTabClientsTable("QUESTIONS", "questions");
      //     break;
      //   case 3:
      //     this.setTabClientsTable("QUESTIONS", "questions");
      //     break;
      //   case 4:
      //     this.setTabClientsTable("QUESTIONS", "questions");
      //     break;
      // }
    },
    disableButton(role) {
      if (role === 7 && this.mainTabPagination.nextTab === 7) {
        return true;
      } else {
        return false
      }

      // else if (role === 7 && this.mainTabPagination.nextTab === 5) {
      //   return true;
      // }
    },
    emmitSetMainTabRight() {
      if (this.mainTabPagination.nextTab < 8) {
        this.paginationEmiter(this.direction);
      }
      switch (this.mainTabPagination.nextTab) {
        case 0:
          // this.setTabClientsTable("STATUS", "status");
          break;
        case 7:
          if (this.auth.user.role !== 7) {
            this.setTabClientsTable("COST", "cost");
          }
          break;
        case 5:
          // if (this.auth.user.role !== 7) {
            this.setTabClientsTable("CAMPAIGN-1", "campaign");
          // }
          break;
        case 6:
          // if (this.auth.user.role !== 7) {
            this.setTabClientsTable("CAMPAIGN-2", "campaign-2");
          // }
          break;
        case 2:
          this.setTabClientsTable("QUESTIONS", "questions");
          break;
        case 3:
          this.setTabClientsTable("QUESTIONS", "questions");
          break;
        case 4:
          this.setTabClientsTable("QUESTIONS", "questions");
          break;
      }
    },
    getNextTab() {
      if (this.direction === "left") {
        this.nextTab = 0;
      }
      if (this.direction === "right") {
        this.nextTab = 1;
      }
    },
    // getNextTab() {
    //   if (this.direction === "left") {
    //      if (this.selectedTabClientTable === "COST") {
    //       this.nextTab = "STATUS";
    //     } else if (this.selectedTabClientTable === "CAMPAIGN") {
    //       this.nextTab = "COST";
    //     } else if (this.selectedTabClientTable === "QUESTIONS") {
    //       switch (questionSector) {
    //         case 1:
    //           this.nextTab = "CAMPAIGN";
    //           break;
    //         case 2:
    //           this.nextTab = "QUESTIONS1";
    //           break;
    //         case 3:
    //           this.nextTab = "QUESTIONS2";
    //           break;
    //       }
    //     }
    //   }
    //   if (this.direction === "right") {
    //     if (this.selectedTabClientTable === "STATUS") {
    //       this.nextTab = "COST";
    //     } else if (this.selectedTabClientTable === "COST") {
    //       this.nextTab = "CAMPAIGN";
    //     } else if (this.selectedTabClientTable === "CAMPAIGN") {
    //       this.nextTab = "QUESTIONS";
    //     } else if (this.selectedTabClientTable === "QUESTIONS") {
    //       switch (questionSector) {
    //         case 1:
    //           this.nextTab = "QUESTIONS1";
    //           break;
    //         case 2:
    //           this.nextTab = "QUESTIONS2";
    //           break;
    //         case 3:
    //           this.nextTab = "QUESTIONS3";
    //           break;
    //       }
    //     }
    //   }
    // },
    getImgSrcByTabName(tabName) {
      switch (tabName) {
        case "COST":
          return require("../../../../../../../public/img/icons/cost_icon.png");
        case "STATUS":
          return require("../../../../../../../public/img/icons/status_icon.png");

        case "LEADS":
          return require("../../../../../../../public/img/icons/leads-icon-6.jpg");
        case "CAMPAIGN":
          return require("../../../../../../../public/img/icons/campain_icon.png");
        case "QUESTIONS":
          return require("../../../../../../../public/img/icons/icon_question.png");
      }
    },
    goToLeads(title) {
      if (title === "LEADS") {
        this.$router.push("/");
      }
    },
    setTabClientsTableToDefault() {
      this.selectedTabClientTable = "LEADS";
      this.$store.commit("clients/setClientsTableSelectedMainTab", "clients");
      this.$store.commit("clients/setClientsTableSelectedTab", "status");
    },
    setTabClientsTable(tabName, tabAlias) {
      if (tabName != "QUESTIONS") {
        // this.questionSector = null;
      }
      this.selectedTabClientTable = tabName;
      this.emitSetClientsTableSelectedTab(tabAlias);
    },
    emitSetClientsTableSelectedTab(tabAlias) {
      this.$store.commit("clients/setClientsTableSelectedTab", {
        tabAlias: tabAlias,
        questionSection: this.questionSector
      });
      if (this.direction === "left") {
        if (this.nextTab > 0) {
          this.nextTab -= 1;
        }
      }
      if (this.direction === "right") {
        if (this.nextTab < 5) {
          this.nextTab += 1;
        }
      }
    },
    getTabList(tabList) {
      if (this.selectedTabClientTable === "QUESTIONS") {
        return tabList;
      } else {
        return tabList.filter(tab => {
          return tab.name !== this.selectedTabClientTable;
        });
      }
    }
  },
  mounted() {
    this.getNextTab();
  }
};
</script>

<style scoped>
.dropdown {
  padding-left: 20px;
  /*margin-right: -50px;*/
  /*padding-top: 6px;*/
  /*background-color: white;*/
  /*padding-top: 8px;*/
}
/*.dropdown-toggle{*/
/*    color: black;*/
/*}*/
.style-nav .router-link {
  max-width: 264px;
  min-width: 72px;
  height: 35px;
  margin: 0;
  cursor: pointer;
  background: white;
  border-radius: 0;
  font-size: 12px;
  color: black;
  text-align: center;
  vertical-align: middle;
  line-height: 35px;
  border-bottom: 2px solid transparent;
  flex-grow: 1;
  transition: background 0.2s ease, color 0.2s ease;
}
a.router-link-exact-active.active.router-link {
  border-bottom: none !important;
}
.sub-menu-dropup .router-link {
  max-width: 264px;
  min-width: 72px;
  /*height: 35px;*/
  margin: 0;
  cursor: pointer;
  background: white;
  border-radius: 0;
  font-size: 10px;
  color: black;
  text-align: center;
  vertical-align: middle;
  /*line-height: 35px;*/
  border-bottom: none !important;
  flex-grow: 1;
  transition: background 0.2s ease, color 0.2s ease;
}

.style-nav.style2 li:not(.empty):hover {
  transform: translateY(5px);
}

.style-nav.style2 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  color: #44a2d2;
}
.sub-menu-dropup .style-nav.style2 li.active {
  border-bottom: none !important;
  color: black;
}

.style-nav.style1 .router-link:not(.empty):hover {
  /*background: #44a2d2;*/
  color: #44a2d2;
  text-decoration: none;
}

.style-nav.style1 .router-link.active {
  border-bottom: 2px solid #44a2d2 !important;
  /*background: #44a2d2;*/
  color: #44a2d2;
  text-decoration: none;
}
.sub-menu-dropup {
  /*min-width: 50px;*/
  /*padding: 10px;*/
  min-width: 30px;
  padding: 7px;
  /*border-radius: 0px;*/
  /*border-bottom: none;*/
  color: gray;
  /*top: -109px;*/
  /*top: -265px;*/
  /*border-radius: 0px 5px 0px 0px;*/
  border: none;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}
.dropdown-item {
  text-decoration: none;
  margin-top: 10px;
  margin-bottom: 10px;
  display: list-item;
  color: black;
  font-size: 10px;
}
.dropdown-item:hover {
  color: #44a2d2;
}
.lead-link {
  cursor: pointer;
}
.navbar-icon-img {
  height: 30px;
}
.tab-sub-menu-btn {
  cursor: pointer;
  color: white;
  background-color: #3b82f6;
  -webkit-transition: background 0.2s ease-in-out;
  transition: background 0.2s ease-in-out;
  margin-left: 1px;
  margin-right: 1px;
  width: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.tab-sub-menu-btn:not(.dis):hover {
  background-color: #2563eb;
}
.tab-sub-menu-btn i {
  color: white !important;
}
.grandfather {
  /*padding-top: 2px;*/
  margin-left: 0px !important;
  margin-right: 5px;
  display: flex;
  height: 100%;
}
.grandfather i {
  /*background-color: green;*/
  height: 25px;
  /*width: 25px;*/
  color: white;
  border-radius: 50%;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  transition: all 0.2s ease-in-out;
}
.grandfather i:hover {
  /*opacity: 0.7;*/
  /*transform: scale(1.1);*/
}
.fa-dollar-sign {
  background-color: #00a700;
}
.fa-question {
  background-color: palevioletred;
}
.fa-bullhorn {
  background-color: orange;
}
.grandfather .fa-bars {
  color: #cbc26f;
}
.grandfather .fa-home {
  color: goldenrod;
  cursor: pointer;
}

.tab-sub-menu-btn .fa-bullhorn {
  /*margin-right: 31px;*/
}
.dropdown-menu {
  top: 68%;
  left: 11px;
}
.button-space {
  margin-top: 14%;
}
.home-wrapper {
  min-width: 35px;
}
.dis {
  cursor: default;
  pointer-events: none;
  opacity: 0.5;
}
.num-in-i {
  font-size: 8px;
}
.tab-sub-menu-btn i {
  color: white !important;
  font-size: 14px;
  margin-top: 0;
}
.fa-arrow-alt-circle-right {
  margin-top: 2px;
}
.tab-sub-menu-btn-left {
  border-radius: 6px 0 0 6px;
  width: 26px;
  background-color: #1d4ed8;
}
.tab-sub-menu-btn-left:not(.dis):hover {
  background-color: #1e40af;
}
.tab-sub-menu-btn-right {
  border-radius: 0 6px 6px 0;
  width: 26px;
  background-color: #1d4ed8;
}
.tab-sub-menu-btn-right:not(.dis):hover {
  background-color: #1e40af;
}
</style>
